(function () {

    // Show more/less text in the collection banner section
    const selectors = {
        section: ".collection-banner",
        "text-container": ".collection-banner__text-container",
        "description-container": ".collection-banner__text-container-text",
        "button-container": ".more-button-container",
        "image-container": ".collection-banner__image-container",
        image: ".collection-banner__image-container img",
        "banner-container": ".collection-banner__inner"
    }

    // Disable More/Less link on mobile phones


    document.addEventListener("DOMContentLoaded", function () {
        const section = document.querySelector(selectors.section);

        if (!section) { // No banner section for this collection
            return;
        }

        const textContainer = section.querySelector(selectors["text-container"]),
            image_container = section.querySelector(selectors["image-container"]),
            bannerContainer = section.querySelector(selectors["banner-container"]);

        if (!image_container) {
            // No image for this collection => we do not have to hide text/show
            return;
        }

        const btn_container = document.querySelector(selectors["button-container"]);
        const btn = btn_container.querySelector("a");

        // Last paragraph hidden
        btn.dataset.state = 0;

        btn.addEventListener("click", function (e) {
            e.preventDefault();
            if(btn.dataset.state == 1) {
                //bannerContainer.classList.add("has-more-text");
                bannerContainer.classList.remove("expanded");
            }else{
                //bannerContainer.classList.remove("has-more-text");
                bannerContainer.classList.add("expanded");
            }
            btn.innerHTML = (btn.dataset.state == 1 ? 'Show More...' : 'Show Less...');
            btn.dataset.state = 1 - btn.dataset.state;
        });

        function updateTextBlock() {

            const imgContainerHeight = image_container.getBoundingClientRect().height;//offsetHeight;
            const textContainerHeight = textContainer.getBoundingClientRect().height;

            if ((textContainerHeight - 30) > imgContainerHeight ) { // More text - show button
                bannerContainer.classList.add("has-more-text");
                bannerContainer.classList.remove("expanded");
                btn_container.style.display = "flex";
            } else {
                bannerContainer.classList.remove("has-more-text");
                btn_container.style.display = "none";
            }
        }

        /**
         *
         * @param func
         * @param delay
         * @return {function(...[*]=): void}
         */
        function debounce(func, delay) {
            // A timer variable to track the delay period
            let timer;
            // Return a function that takes arguments
            return function (...args) {
                // Clear the previous timer if any
                clearTimeout(timer);
                // Set a new timer that will execute the function after the delay period
                timer = setTimeout(() => {
                    // Apply the function with arguments
                    func.apply(this, args);
                }, delay);
            };
        }

        const debouncedHandler = debounce(updateTextBlock, 50);

        window.addEventListener("load", (event) => updateTextBlock());
        window.addEventListener("resize", (event) => debouncedHandler());
    });
})();